import { DOMAIN } from './TrusthubPageDetails.actions';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || {};

export const getIsCreateLoading = state => Boolean(getStore(state).isCreateLoading);
